import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { minorConsentFaqs } from "@/mocks/legalPages";

/** 未成年の方へ｜よくあるご質問（アコーディオン）。 */
export default function MinorFaq() {
  const [openId, setOpenId] = useState<string | null>(minorConsentFaqs[0]?.id ?? null);

  return (
    <section className="bg-background-50 py-20 md:py-28 lg:py-32">
      <div className="u-container">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <SectionHeading en="Q&amp;A" jp="よくあるご質問" />
          </Reveal>

          <Reveal delay={100}>
            <div className="mt-10 border-t border-background-300/80">
              {minorConsentFaqs.map((faq) => {
                const isOpen = openId === faq.id;
                return (
                  <div key={faq.id} className="border-b border-background-300/80">
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : faq.id)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-6 py-6 text-left"
                    >
                      <span className="flex items-start gap-4">
                        <span className="font-label text-[13px] text-secondary-700">Q</span>
                        <span className="font-heading text-[15px] leading-[1.8] text-foreground-950 md:text-base">
                          {faq.q}
                        </span>
                      </span>
                      <i
                        className={`shrink-0 text-xl text-foreground-600 transition-transform duration-300 ${
                          isOpen ? "rotate-45" : ""
                        }`}
                        aria-hidden
                      >
                        <span className="ri-add-line" />
                      </i>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <div className="flex items-start gap-4 pb-7">
                          <span className="font-label text-[13px] text-accent-700">A</span>
                          <p className="text-[13px] leading-[2.1] text-foreground-700 md:text-sm">
                            {faq.a}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}